import _ from "lodash";
/**
 * Erreur renvoyée par l'api
 */
export default class HttpAppResponseErrorException {
  /**
   * Erreur renvoyée par l'api
   * @param {*} errorData
   */
  constructor(errorData) {
    if (HttpAppResponseErrorException.isHttpAppResponseError(errorData)) {
      Object.assign(this, errorData);
    }
  }

  /**
   * Obtient le tableau des échecs de validation.
   * @param {HttpAppResponseErrorException} httpAppResponseError
   * @returns
   */
  static getValidationFailures(httpAppResponseError) {
    return httpAppResponseError.validationError?.failures ?? [];
  }

  /**
   * Renvoie un tableau de messages d'erreur de l'api
   * @param {Object} httpAppResponseError Erreur renvoyée par l'api
   * @returns {Array<String>} tableau de messages d'erreur
   */
  static toErrorMessages(httpAppResponseError) {
    let errorMessages = [];

    if (HttpAppResponseErrorException.isHttpAppResponseError(httpAppResponseError)) {
      if (httpAppResponseError.validationError) {
        //erreur de validation
        errorMessages = httpAppResponseError.validationError.failures.map((f) => f.errorMessage);
        if (errorMessages.length === 0) {
          errorMessages.push(httpAppResponseError.validationError.message);
        }
      } else {
        //autres erreurs
        errorMessages = [
          httpAppResponseError.innerExceptionType,
          httpAppResponseError.exceptionType,
          httpAppResponseError.innerExceptionMessage,
          httpAppResponseError.message,
        ].filter((m) => m != null);
      }
    }

    return errorMessages;
  }

  /**
   * Indique si l'objet est l'erreur renvoyée par le web api.
   * @param {*} httpAppResponseError
   * @returns
   */
  static isHttpAppResponseError(httpAppResponseError) {
    return httpAppResponseError?.message != undefined || httpAppResponseError?.validationError != undefined;
  }
  /**
   * Retire la class css de l'élément invalide
   * @param {HtmlElement} inputEl élément html invalide
   * @param {String} invalidCssClass name de la class à retirer
   */
  static removeInvalidCssClass(inputEl, invalidCssClass = "is-invalid") {
    if (inputEl) {
      inputEl.classList.remove(invalidCssClass);
    }
  }

  /**
   * Ajoute la class css invalid à l'input
   * @param {*} propertyName name de la propriété de la validation venant du serveur
   * @param {*} inputEl
   * @param {*} validationFailures
   * @param {*} invalidCssClass
   */
  static addInvalidCssClass(propertyName, inputEl, validationFailures, invalidCssClass = "is-invalid") {
    if (inputEl) {
      inputEl.classList.remove(invalidCssClass);
      if (
        validationFailures.some((f) => {
          return f.propertyName === propertyName || f.propertyName === _.upperFirst(propertyName);
        })
      ) {
        inputEl.classList.add(invalidCssClass);
      }
    }
  }

  /**
   * Retire la class css invalid de tous les inputs du formualaire.
   * @param {Array<String>} fieldNames les noms des champs du formulaire
   * @param {HtmlElement} containerElement l'élément containeur html du formulaire
   * @param {Function} querySelectorFunc Fonction renvoyant le sélecteur css des inputs avec en paramètre le name du champ.
   * @param {*} invalidCssClass la classe css invalid
   */
  static removeAllInvalidCssClass(containerElement, invalidCssClass = "is-invalid") {
    let inputEls = containerElement.querySelectorAll("." + invalidCssClass);
    for (let inputEl of inputEls) {
      HttpAppResponseErrorException.removeInvalidCssClass(inputEl, invalidCssClass);
    }
  }

  /**
   * Ajoute la class css invalid à tous les inputs du formulaire
   * @param {*} containerElement l'élément conteneur html du formulaire
   * @param {*} querySelectorFunc Fonction renvoyant le sélecteur css des inputs avec en paramètre le name du champ.
   * @param {*} validationFailures les échecs de validation
   * @param {*} invalidCssClass la classe css invalid
   * @param {*} keysMapping correspondance entre le name des propriétés de la validation venant du serveur et le name des champs du formulaire lorsqu'ils sont différents
   */
  static addlAllInvalidCssClass(containerElement, querySelectorFunc, validationFailures, keysMapping = null, invalidCssClass = "is-invalid") {
    const propertyNames = validationFailures.map((f) => f.propertyName).filter((p) => p?.length > 0);
    for (let propertyName of propertyNames) {
      const fieldName = (keysMapping || {})[propertyName] || propertyName;

      if (fieldName) {
        let inputEl = containerElement.querySelector(querySelectorFunc(fieldName));
        HttpAppResponseErrorException.addInvalidCssClass(propertyName, inputEl, validationFailures, invalidCssClass);
      }
    }
  }
}
